import React, { useContext, useState, useEffect, useRef } from "react";
import { useNavigate, Link, useParams } from 'react-router-dom';
import { InvoiceContainer, Profile } from "./InvoiceStyled";
import { FormattedMessage, useIntl } from 'react-intl';

import { UserContext } from "../../context/userContext";
import { LangContext } from "../../context/langContext";

import back from './../../utils/images/arrow_back.svg';
import print from './../../utils/images/print.svg';
import avatar from './../../utils/images/avatar_fluincr.png';

import InfluencerCardInvoice from '../../components/InfluencerCardInvoice/InfluencerCardInvoice';
import { getAllInfluencersFilter, getFeaturedInfluencers } from "../../api/influencerApi";
import { getCollaborationById } from "../../api/collaborationApi";
import { fill, formatNumber } from "../../services/generalSevices";
import { formatDateLocal, fromUTCtoLocal, newFormat, toUTCString } from "../../services/dateServices";
import Spinner from "../../components/Spinner/Spinner";


import ReactToPrint from 'react-to-print';

export default function Invoice() {

    const navigate = useNavigate();
    const { idCollaboration } = useParams();

    const divPrintRef = useRef(null);

    const { locale } = useContext(LangContext);

    const { userType, userToken, imageProfile, name, companyName, city, country, address, phone, indicativePhone, email, typeIdentification, identification, companyId, account } = useContext(UserContext);

    const [isLoading, setIsLoading] = useState(true);
    const [limit, setLimit] = useState(5);
    const [featuredInfluencers, setFeaturedInfluencers] = useState([]);

    const [InvoiceNumber, setInvoiceNumber] = useState(0);
    const [collaborationDate, setCollaborationDate] = useState('');
    const [collaborationTotal, setCollaborationTotal] = useState(0);
    const [collaborationTaxes, setCollaborationTaxes] = useState(0);
    const [collaborationDiscount, setCollaborationDiscount] = useState(0);

    // const [companyData, setCompanyData] = useState({});
    const [influencerData, setInfluencerData] = useState({});
    const [productData, setProductData] = useState({});

    const [collaborationContents, setCollaborationContents] = useState([]);
    const [sendGift, setSendGift] = useState(false);
    const [giftValue, setGiftValue] = useState(0);
    const [paypalOrderId, setPaypalOrderId] = useState();

    useEffect(() => {

        getAllInfluencersFilter({ companyId: companyId, query: '&featured=eq.true', limit: limit, offset: 0 }).then(({ data, pagination }) => {
            setFeaturedInfluencers(data)
        })

        if (userToken !== null) {
            getCollaborationById({ collaborationId: idCollaboration, token: userToken }).then((response) => {

                setInvoiceNumber(response.id)
                setCollaborationDate(response.creation);
                setCollaborationTotal(response.totalPrice);
                //setCompanyData(response.company);
                setInfluencerData(response.influincr);
                setProductData(response.product);
                setCollaborationContents(response.item)
                setSendGift(response.gift);
                setGiftValue(response.giftValue);
                setPaypalOrderId(response?.paypalorder_id);

                if (response.message === 'error') {
                    navigate('/error')
                }

                setIsLoading(false);
            })
        }


    }, [userToken, idCollaboration])


    /* function printDiv(nombreDiv) {
        var contenido = document.getElementById(nombreDiv).innerHTML;
        var contenidoOriginal = document.body.innerHTML;

        document.body.innerHTML = contenido;

        window.print();

        document.body.innerHTML = contenidoOriginal;
    } */

    return (
        <InvoiceContainer>
            <div className="goBack" onClick={() => navigate(-1)}  >
                <img src={back} alt="go back" className="backIcon" />
                <p>
                    <FormattedMessage id="go_back" defaultMessage="ir atrás" />
                </p>
            </div>
            {(isLoading) ? (<Spinner />) : (
                <div className="invoiceBody" >

                    <section className="invoice" id='invoicePrint' >

                        <h2 className="invoiceTitle"> <FormattedMessage id="voucher_title_a" defaultMessage="Factura de tu colaboración" /></h2>

                        <div className="invoiceData">

                            <div className="information">
                                <p className="subtitle"><FormattedMessage id="voucher_text_1_a" defaultMessage="Factura #" />
                                    {fill(InvoiceNumber, 8)}</p>
                                <div className="userData">
                                    <div className="profile">
                                        <Profile image={imageProfile ? imageProfile : avatar} />
                                        <p className="name" style={{ textTransform: 'capitalize' }}>{(userType === 'influencer') ? (name) : (companyName)}</p>
                                    </div>
                                    <div className="data">

                                        <p className="accountId"><FormattedMessage id="voucher_text_2" defaultMessage="Cuenta #" />{account}</p>
                                        <p>{city && `${city}, `}{(locale === 'es-CO') ? (country.nombre) : (country.name)}</p>
                                        <p>{address}</p>
                                        <p>NIT {identification}</p>
                                        {/* <p>{(phone !== '' && phone !== null) && (<span>{`+(${indicativePhone}) ${phone}`}</span>)}</p>
                                        <p>{email}</p> */}

                                    </div>

                                </div>
                            </div>

                            <div className="prices">
                                <div className="subtitle">
                                    {(collaborationDate !== '') && (<p className="date">{/* {formatDateLocal(fromUTCtoLocal(collaborationDate))} */}{newFormat(collaborationDate)}</p>
                                    )}

                                    <ReactToPrint
                                        trigger={() => <button className="printButton"><img src={print} alt="print" className="print" /></button>}
                                        content={() => divPrintRef.current}
                                    />

                                </div>

                                <table>
                                    <tr>
                                        <td><FormattedMessage id="voucher_text_3" defaultMessage="Subtotal" /></td>
                                        <td className="price">$ {formatNumber(collaborationTotal)}</td>

                                    </tr>

                                    <tr>
                                        <td><FormattedMessage id="voucher_text_4" defaultMessage="Impuestos" /></td>
                                        <td className="price">$ {formatNumber(collaborationTaxes)}</td>
                                    </tr>
                                    <tr>
                                        <td><FormattedMessage id="voucher_text_5" defaultMessage="Descuento" /></td>
                                        <td className="price">- $ {formatNumber(collaborationDiscount)}</td>
                                    </tr>
                                    <tr>
                                        <td><FormattedMessage id="voucher_text_6" defaultMessage="Total" /></td>
                                        <td className="price">$ {formatNumber(collaborationTotal - collaborationTaxes - collaborationDiscount)}</td>
                                    </tr>
                                    <tr>
                                        <td><FormattedMessage id="voucher_text_7" defaultMessage="Pago" /> #{paypalOrderId}</td>
                                        <td className="price">($ {formatNumber(collaborationTotal - collaborationTaxes - collaborationDiscount)})</td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <hr />

                        <div className="companyData">
                            <div className="profile">
                                <Profile image={influencerData.imageProfile ? influencerData.imageProfile : avatar} />
                                <p className="name" style={{ textTransform: 'capitalize' }}>{influencerData?.givenName} {influencerData?.familyName}</p>
                            </div>
                            <div className="companyDetails">

                                <p className="accountId"><FormattedMessage id="voucher_text_2" defaultMessage="Cuenta #" />{influencerData.account}</p>
                                <p>{influencerData?.city && `${influencerData.city}, `}{(locale === 'es-CO') ? (influencerData?.country?.nombre) : (influencerData?.country?.name)}</p>
                                <p>{influencerData?.address}</p>
                                <p>ID {influencerData?.attributes?.numberId}</p>
                                {/* <p>{influencerData?.phoneNumber && (<span>{`+(${influencerData?.indicative})`} {influencerData.phoneNumber}</span>)}</p>
                                <p>{influencerData?.mail}</p> */}

                            </div>
                        </div>
                        <div className="collaborationData">
                            <div className="profile">
                                <Profile image={productData?.image ? productData.image : avatar} />
                                <p className="name" style={{ textTransform: 'capitalize' }}>{productData?.name}</p>
                            </div>
                            <table>

                                {collaborationContents.map((item) => {
                                    return (<tr key={item.id}>
                                        <td><FormattedMessage id="voucher_text_9" defaultMessage="Contenido #" /> {fill(item.id)} <span style={{ textTransform: 'capitalize' }}>({(locale === 'es-CO') ? (JSON.parse(item.title).nombre) : (JSON.parse(item.title).name)})</span></td>
                                        <td className="price">$ {formatNumber(item.price)}</td>
                                    </tr>)
                                })}

                                {/*  <tr>
                                    <td><FormattedMessage id="voucher_text_10" defaultMessage="Promoción" /> xx%</td>
                                    <td className="price">$ 0</td>
                                </tr> */}


                                <tr>
                                    <td>
                                        <FormattedMessage id="voucher_text_11" defaultMessage="Producto/servicio gratuito" />
                                    </td>
                                    {(sendGift) ? (<td className="price">- $ {formatNumber(giftValue)}</td>) : (<td className="price">- $ 0</td>)}
                                </tr>

                            </table>

                        </div>
                    </section>

                    <hr className="verticalLine" />

                    <section className="featured">
                        <h3 className="subtitle"><FormattedMessage id="voucher_subtitle_1" defaultMessage="¿Estás listo para tu próxima colaboración?" /></h3>

                        <p className="featuredSubtitle"><FormattedMessage id="voucher_subtitle_2" defaultMessage="Influencers destacados" /></p>

                        <div className="content">
                            <Link to={"/influencers"}>
                                <FormattedMessage id="home_more_text" defaultMessage="Ver más +" />
                            </Link>
                            <div className="cards influencers">

                                {featuredInfluencers.map((influencer) => (
                                    <InfluencerCardInvoice influencer={influencer} key={influencer.id} page='voucher' />
                                ))}
                            </div>
                        </div>

                    </section>

                    {/**-----------TO PRINT-------------- */}
                    <section className="invoiceToPrint" id='invoicePrint' ref={divPrintRef}>

                        <h2 className="invoiceTitle"> <FormattedMessage id="voucher_title_a" defaultMessage="Factura de tu colaboración" /></h2>
                        <br />
                        <div className="invoiceData">

                            <div className="information">
                                <p className="subtitle"><FormattedMessage id="voucher_text_1_a" defaultMessage="Factura #" />
                                    {fill(InvoiceNumber, 8)}</p>
                                <div className="userData">
                                    <div className="profile">
                                        <Profile image={imageProfile ? imageProfile : avatar} />
                                        <p className="name" style={{ textTransform: 'capitalize' }}>{(userType === 'influencer') ? (name) : (companyName)}</p>
                                    </div>
                                    <div className="data">

                                        <p className="accountId"><FormattedMessage id="voucher_text_2" defaultMessage="Cuenta #" />{account}</p>
                                        <p>{city && `${city}, `}{(locale === 'es-CO') ? (country.nombre) : (country.name)}</p>
                                        <p>{address}</p>
                                        <p>NIT {identification}</p>
                                        {/* <p>{(phone !== '' && phone !== null) && (<span>{`+(${indicativePhone}) ${phone}`}</span>)}</p>
                                        <p>{email}</p> */}

                                    </div>

                                </div>
                            </div>

                            <div className="prices">
                                <div className="subtitle">
                                    {(collaborationDate !== '') && (<p className="date">{/* {formatDateLocal(fromUTCtoLocal(collaborationDate))} */}{newFormat(collaborationDate)}</p>
                                    )}
                                </div>

                                <table>
                                    <tr>
                                        <td><FormattedMessage id="voucher_text_3" defaultMessage="Subtotal" /></td>
                                        <td className="price">$ {formatNumber(collaborationTotal)}</td>

                                    </tr>

                                    <tr>
                                        <td><FormattedMessage id="voucher_text_4" defaultMessage="Impuestos" /></td>
                                        <td className="price">$ {formatNumber(collaborationTaxes)}</td>
                                    </tr>
                                    <tr>
                                        <td><FormattedMessage id="voucher_text_5" defaultMessage="Descuento" /></td>
                                        <td className="price">- $ {formatNumber(collaborationDiscount)}</td>
                                    </tr>
                                    <tr>
                                        <td><FormattedMessage id="voucher_text_6" defaultMessage="Total" /></td>
                                        <td className="price">$ {formatNumber(collaborationTotal - collaborationTaxes - collaborationDiscount)}</td>
                                    </tr>
                                    <tr>
                                        <td><FormattedMessage id="voucher_text_7" defaultMessage="Pago" /> #{paypalOrderId}</td>
                                        <td className="price">($ {formatNumber(collaborationTotal - collaborationTaxes - collaborationDiscount)})</td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <br />
                        <hr />
                        <br />

                        <div className="companyData">
                            <div className="profile">
                                <Profile image={influencerData.imageProfile ? influencerData.imageProfile : avatar} />
                                <p className="name" style={{ textTransform: 'capitalize' }}>{influencerData?.givenName} {influencerData?.familyName}</p>
                            </div>
                            <div className="companyDetails">

                                <p className="accountId"><FormattedMessage id="voucher_text_2" defaultMessage="Cuenta #" />{influencerData.account}</p>
                                <p>{influencerData?.city && `${influencerData.city}, `}{(locale === 'es-CO') ? (influencerData?.country?.nombre) : (influencerData?.country?.name)}</p>
                                <p>{influencerData?.address}</p>
                                <p>ID {influencerData?.attributes?.numberId}</p>
                                {/* <p>{influencerData?.phoneNumber && (<span>{`+(${influencerData?.indicative})`} {influencerData.phoneNumber}</span>)}</p>
                                <p>{influencerData?.mail}</p> */}

                            </div>
                        </div>
                        <br />
                        <div className="collaborationData">
                            <div className="profile">
                                <Profile image={productData?.image ? productData.image : avatar} />
                                <p className="name" style={{ textTransform: 'capitalize' }}>{productData?.name}</p>
                            </div>
                            <table>

                                {collaborationContents.map((item) => {
                                    return (<tr>
                                        <td><FormattedMessage id="voucher_text_9" defaultMessage="Contenido #" /> {fill(item.id)} <span style={{ textTransform: 'capitalize' }}>({(locale === 'es-CO') ? (JSON.parse(item.title).nombre) : (JSON.parse(item.title).name)})</span></td>
                                        <td className="price">$ {formatNumber(item.price)}</td>
                                    </tr>)
                                })}

                                {/* <tr>
                                    <td><FormattedMessage id="voucher_text_10" defaultMessage="Promoción" /> xx%</td>
                                    <td className="price">$ 0</td>
                                </tr> */}

                                <tr>
                                    <td><FormattedMessage id="voucher_text_11" defaultMessage="Producto/servicio gratuito" /></td>
                                    {(sendGift) ? (<td className="price">- $ {formatNumber(giftValue)}</td>) : (<td className="price">- $ 0</td>)}

                                </tr>
                            </table>

                        </div>
                    </section>
                </div>
            )}


        </InvoiceContainer>
    )
}